export class RatePlanChangedFields {
    minStay = false;
    maxStay = false;
    minBookable = false;
    maxBookable = false;
    priceDiffType = false;
    priceDiff = false;
} 

export class PromoCode {
    id = 0;
    name = "";
    priceDifference = 0 as number | null;
    priceDifferenceIsAbsolute = false;
    currencyId = 0 as number | undefined;
    isForAccommodation = false;
    isForService = false;
    applicationMethodId = 1;
}

export class RatePlanModel {
    id?: number;
    name = "";
    
    isSpecialOrPackageOffer = false;

    includesBreakFast = false;
    includesLunch = false;
    includesDinner = false;
    defaultServiceTypeId?: number;
    minimumStay?: number = 1;
    maximumStay?: number;
    minBookableBeforeCheckin?: number;
    maxBookableBeforeCheckin?: number;
    isDerived = false;
    parentRatePlanId?: number;
    priceDifference?: number;
    priceDifferenceIsAbsolute?: boolean;
    appliesToAllAccomodationUnitTypes = false;
    maxNumOfInstalments = 1;

    accomodationBookingFee = null as number | null;
    addOnServicesBookingFee = null as number | null;
    mergeAllBookingFeesIntoSingleItem = true;
    
    isAvailableViaBookingEngine = false;
    bookingEnginePriceOffset?: number;
    alwaysShowOnBoookingEngine = false;

    ratePlanOtas: RatePlanOtas[] = [];
    ratePlansCancelPoliciesIds: number[] = [];
    ratePlansPrepaymentPoliciesIds: number[] = [];
    promoCode = null as PromoCode | null;
    
    accomodationUnitTypeIds = [] as number[];
    ratePlanAccomodationUnitTypes = [] as RatePlanAccomodationUnitType[];
    
    translations = [] as RatePlanTranslation[];
    
    // special offer fields
    bookableFrom?: string;
    bookableUntil?: string;
    arrivalDateFrom?: string;
    arrivalDateUntil?: string;
    requiresEmailToUnlock = false;
    requiresNameToUnlock = false;
    requiresTelephoneNumberToUnlock = false;
    maxSellableGrossIncome?: number;
    maxSellableNights?: number;
    maxSellableReservations?: number;
    emphasizeOnBefeaturedOffers = false;
    emphasizeOnBepreheader = false;
    updateExistingAvailability = false;
    hasPhoto = false;
    
    addOnServices: RatePlanAddOnService[] = [];
    currencyId?: number;
    
    changedFields: RatePlanChangedFields = new RatePlanChangedFields();
}

export interface RatePlanAccomodationUnitType {
    id: number;
    accomodationUnitTypeId: number;
    accomodationUnitTypesPAXCategoryId: number;
    accomodationUnitTypesLOSCategoryId: number;

    priceDifference: number | null;
    priceDifferenceIsAbsolute: boolean | null;
}

export interface RatePlanOtas {
    otaid: number;
    name: string;
    priceDifference: number | null;
}

export interface RatePlanOccupancyBasedRule extends RatePlanAccomodationUnitType {
    minPersons: number;
    maxPersons: number;
    minStay: number;
    maxStay: number;
    isDefault: boolean;
}

export interface RatePlanTilesModel {
    id: number;
    name: string;
    isNonRefundable: boolean;
    currencyId: number;
    currencyCode: string;
    
    includesBreakfast: boolean;
    includesLunch: boolean;
    includesDinner: boolean;
    
    minimumStay: number;
    maximumStay: number;
    minBookableBeforeCheckin: number;
    maxBookableBeforeCheckin: number;
    
    isDerived: boolean;
    parentRatePlanId: number;
    parentRatePlanName: string;
    priceDifference: string;
    priceDifferenceIsAbsolute?: boolean;
    
    appliesToAllAccomodationUnitTypes: boolean;
    numberOfAccomodationUnitTypesRatePlanIsAppliedTo: number;
    numberOfPropertiesPlanIsAppliedTo: number;
    numberOfCancelationPolicies: number;
    numberOfPrepaymentPolicies: number;
    otas: string[];
    
    isAvailableViaBookingEngine: boolean;
    bookingEnginePriceOffset?: number;
    
    isSpecialOffer: boolean;
    isExpired: boolean;
    isDeactivated: boolean;
}

export interface NonDerivedRatePlanModel {
    id: number;
    name: string;
    appliesToAllAccomodationUnitTypes: boolean;
}

export class RatePlanTranslation {
    id = 0;
    cultureCode = "";
    translation = "";
    subtitleTranslation = "";
    descriptionTranslation = "";
}

export class RatePlanAddOnService {
    id = 0;
    addOnServiceId = 0;
    addOnServiceName = "";
    defaultQuantity = 0;
    guestCanChangeQuantity = false;
    isIncludedInPrice = false;
    discountPercent = 0;
    calculationMethodId = 0 as number | undefined;
}

export enum RatePlanTypeFilterEnum {
  All = 1,
  Normal = 2,
  ActiveOffers = 3,
  AllOffers = 4
}

export interface UnitTypeViewModel {
    accomodationUnitTypeId: number;
    name: string;
    propertyId: number;
    propertyName: string;

    paxlosCombinations: UnitTypePAXLOSCombination[];
}

export interface UnitTypePAXLOSCombination {
    accomodationUnitTypesPAXCategoryId: number;
    accomodationUnitTypesLOSCategoryId: number;
    minPersons: number;
    maxPersons: number;
    minStay: number;
    maxStay: number;
    isDefault: boolean;
}